import AlertBox from './AlertBox';

export default AlertBox;



// WEBPACK FOOTER //
// ./src/components/AlertBox/index.js